<template>

    <v-container>
        <v-row class="justify-center print-hide">
            <v-col cols="12">
                <v-row class="body-2 font-weight-light">
                    <!--            <v-breadcrumbs class="breadcrumbs pa-0" :items="breadcrumbs"></v-breadcrumbs>-->
                    <v-spacer></v-spacer>
                    <span>{{ $todayDate() }}</span>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="print-hide" align="center" justify="center">
            <v-col cols="12" md="8">
                <v-autocomplete
                        outlined
                        :items="cantons.items"
                        item-text="title"
                        item-value="id"
                        hide-details
                        label="Odaberi županiju.."
                        v-model="select_canton"
                        dense
                        @change="getEducationalFieldsTable"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row class="justify-center print-hide">
            <v-col cols="12" sm="10" md="8">
                <v-treeview
                        :items="educationalFields"
                        id="tree"
                >
                    <template slot="append" slot-scope="props">
                        <v-btn v-if="!props.item.children"
                               icon
                               @click="changeEducationalFieldId(props.item);scroll();"

                        >
                            <v-icon color="primary">mdi-eye-check-outline</v-icon>
                        </v-btn>
                    </template>

                </v-treeview>
            </v-col>
        </v-row>
        <!--    <v-row class="print-show">-->
        <!--      <div style="display: flex; width: 100%; margin-bottom: 10px">-->
        <!--        <img v-if="select_canton === 9" style="margin-left: 50px; width: 300px !important"-->
        <!--             src="../../assets/img/zhzzupanija.png"/>-->
        <!--        <img v-else-if="select_canton === 8" style="margin-left: 50px; width: 300px !important"-->
        <!--             src="../../assets/img/zenicka.png"/>-->
        <!--        <img v-else-if="select_canton === 5" style="margin-left: 50px; width: 300px !important"-->
        <!--             src="../../assets/img/sbzzupanija.png"/>-->
        <!--        <img v-else-if="select_canton === 4" style="margin-left: 50px; width: 300px !important"-->
        <!--             src="../../assets/img/pzupanija.png"/>-->
        <!--        <img v-else-if="select_canton === 3" style="margin-left: 50px; width: 200px !important"-->
        <!--             src="../../assets/img/hnzzupanija.png"/>-->
        <!--        <img v-else-if="select_canton === 2" style="margin-left: 50px; width: 300px !important"-->
        <!--             src="../../assets/img/hbzupanija.png" />-->
        <!--        <div style="text-align: right; position: absolute; right: 50px;">-->
        <!--&lt;!&ndash;          <h4>{{ selected_canton_title }}</h4>&ndash;&gt;-->
        <!--          <h3>Nastavni plan</h3>-->
        <!--          <h4 v-if="!primarySchool">Srednja škola</h4>-->
        <!--          <h4>{{ selectedSchool }}</h4>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </v-row>-->
        <v-row class="print-show">
            <div v-if="select_canton === 9" style="display: flex; width: 100%; margin-bottom: 10px;">
                <img style="width: 35% !important"
                     src="../../assets/img/zhzzupanija.png"/>
                <div style=" width:30%; text-align: center;">
<!--                    <h4 class="color">Nastavni plan</h4>-->
<!--                    <h5 class="color" v-if="!primarySchool">Srednja škola</h5>-->
<!--                    <h5 class="color">{{ selectedSchool }}</h5>-->
                </div>
                <div align="right"><img class="print-show right" width="40%" src="../../assets/img/footer2.png"/></div>
            </div>

            <div v-else-if="select_canton === 5" style="display: flex; width: 100%; margin-bottom: 10px">
                <img style="width: 35% !important"
                     src="../../assets/img/sbzzupanija.png"/>
                <div style=" width:30%; text-align: center;">
                    <!--                    <h4 class="color">Nastavni plan</h4>-->
                    <!--                    <h5 class="color" v-if="!primarySchool">Srednja škola</h5>-->
                    <!--                    <h5 class="color">{{ selectedSchool }}</h5>-->
                </div>
                <div align="right"><img class="print-show right" width="40%" src="../../assets/img/footer2.png"/></div>
            </div>

            <div v-if="select_canton === 4" style="display: flex; width: 100%; margin-bottom: 10px;">
                <img style=" width: 35% !important"
                     src="../../assets/img/pzupanija.png"/>
                <div style=" width:30%; text-align: center;">
                    <!--                    <h4 class="color">Nastavni plan</h4>-->
                    <!--                    <h5 class="color" v-if="!primarySchool">Srednja škola</h5>-->
                    <!--                    <h5 class="color">{{ selectedSchool }}</h5>-->
                </div>
            <div align="right"><img class="print-show right" width="40%" src="../../assets/img/footer2.png"/></div>

            </div>

          <div v-if="select_canton === 3" style="display: flex; width: 100%; margin-bottom: 10px">
            <img style="width: 35% !important"
                 src="../../assets/img/HNZ_1.png"/>
              <div style=" width:30%; text-align: center;">
                  <!--                    <h4 class="color">Nastavni plan</h4>-->
                  <!--                    <h5 class="color" v-if="!primarySchool">Srednja škola</h5>-->
                  <!--                    <h5 class="color">{{ selectedSchool }}</h5>-->
              </div>
              <div align="right"><img class="print-show right" width="40%" src="../../assets/img/footer2.png"/></div>
          </div>


          <div v-if="select_canton === 2" style="display: flex; width: 100%; margin-bottom: 10px">
            <img style="width: 35% !important"
                 src="../../assets/img/hbzupanija.png"/>
            <div style=" width: 30%; text-align: center;">
<!--              <h4 class="color">Nastavni plan</h4>-->
<!--              <h5 class="color" v-if="!primarySchool">Srednja škola</h5>-->
<!--              <h5 class="color">{{ selectedSchool }}</h5>-->
            </div>
              <div align="right"><img class="print-show right" width="40%" src="../../assets/img/footer2.png"/></div>
          </div>

            <div v-if="select_canton === 8" style="display: flex; width: 100%; margin-bottom: 10px">
<!--                <img style="width: 35% !important"-->
<!--                     src="../../assets/img/usora.png"/>-->
                <div style=" width: 35%;">
                    <!--              <h4 class="color">Nastavni plan</h4>-->
                    <!--              <h5 class="color" v-if="!primarySchool">Srednja škola</h5>-->
                    <!--              <h5 class="color">{{ selectedSchool }}</h5>-->
                </div>
                <div style=" width: 30%; text-align: center;">
                    <!--              <h4 class="color">Nastavni plan</h4>-->
                    <!--              <h5 class="color" v-if="!primarySchool">Srednja škola</h5>-->
                    <!--              <h5 class="color">{{ selectedSchool }}</h5>-->
                </div>
<!--                <img style="width: 35% !important"-->
<!--                     src="../../assets/img/zepce.png"/>-->
                <div align="right"><img class="print-show right" width="40%" src="../../assets/img/footer2.png"/></div>
            </div>
            <div style="width: 100%; text-align: center">
                <h7 class="color">Nastavni plan -  </h7>
                <h7 class="color" v-if="!primarySchool">Srednja škola   -  </h7>
                <h7 class="color">{{ selectedSchool }}</h7>
            </div>


        </v-row>


        <row class="print-show top-right">
            <span>Datum i vrijeme ispisa iz SUMIT matice: {{ $todayDate()  }} {{timestamp}} </span>
        </row>
<!--        <row class="print-show top-left">-->
<!--            <span>Tablica prikazuje tjedni broj sati predmeta u određenom razredu.</span>-->
<!--        </row>-->
        <v-row id="table_npp" v-if="showTable">
            <v-col cols="12" class="print-hide text-right">
                <v-btn  width="120" @click="print()" class="text-none" outlined color="primary">
                    <v-icon left>mdi-printer</v-icon>
                    Ispis
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-data-table dense
                              :headers="headers"
                              :items="items"
                              class="plans-table"
                              loading-text="Traženje..."
                              :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
                              :header-props="{sortByText: 'Poredaj po'}"
                              hide-default-footer
                              disable-pagination
                >

                    <template v-slot:[`item.subject_group_subjects[11]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '11')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '11').weekly_classes === 0 ? '':  item.subject_group_subjects.find(item => item.school_class === '11').weekly_classes }}
                            {{ (item.subject_group_subjects.find(item => item.school_class === '11').weekly_classes_practice) === 0 ? '':(item.subject_group_subjects.find(item => item.school_class === '11').weekly_classes_practice)+'*'}}
                        </div>
                        <div v-else>
                            -
                        </div>
                        <!--            <template v-for="(it, i) in item.subject_group_subjects">-->
                        <!--              <div :key="i" v-if="it.school_class === '11'">-->
                        <!--                <span>{{it.weekly_classes}}</span>-->
                        <!--              </div>-->
                        <!--            </template>-->
                    </template>
                    <template v-slot:[`item.subject_group_subjects[12]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '12')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '12').weekly_classes === 0 ? '':  item.subject_group_subjects.find(item => item.school_class === '12').weekly_classes }}
                            {{ item.subject_group_subjects.find(item => item.school_class === '12').weekly_classes_practice === 0 ? '':(item.subject_group_subjects.find(item => item.school_class === '12').weekly_classes_practice)+'*'}}
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[13]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '13')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '13').weekly_classes === 0 ? '':  item.subject_group_subjects.find(item => item.school_class === '13').weekly_classes }}
                            {{ (item.subject_group_subjects.find(item => item.school_class === '13').weekly_classes_practice) ===0 ? '':(item.subject_group_subjects.find(item => item.school_class === '13').weekly_classes_practice)+'*' }}
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[14]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '14')" >
                            {{ item.subject_group_subjects.find(item => item.school_class === '14').weekly_classes === 0 ? '':  item.subject_group_subjects.find(item => item.school_class === '14').weekly_classes }}
                            {{ (item.subject_group_subjects.find(item => item.school_class === '14').weekly_classes_practice) ===0 ? '':(item.subject_group_subjects.find(item => item.school_class === '14').weekly_classes_practice)+'*'  }}
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[0]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '1')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '1').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                        <!--            <template v-for="(it, i) in item.subject_group_subjects">-->
                        <!--              <div :key="i" v-if="it.school_class === '1'">-->
                        <!--                <span v-if="it.weekly_classes">{{ it.weekly_classes }}</span>-->
                        <!--              </div>-->
                        <!--            </template>-->
                    </template>
                    <template v-slot:[`item.subject_group_subjects[1]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '2')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '2').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[2]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '3')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '3').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[3]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '4')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '4').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[4]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '5')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '5').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[5]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '6')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '6').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[6]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '7')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '7').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[7]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '8')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '8').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>
                    <template v-slot:[`item.subject_group_subjects[8]`]="{ item }">
                        <div v-if="item.subject_group_subjects.find(item => item.school_class === '9')">
                            {{ item.subject_group_subjects.find(item => item.school_class === '9').weekly_classes }}
                        </div>
                        <div v-else>
                            0
                        </div>
                    </template>


                    <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.

            </span>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

<!--        <div class="print-show" >-->

<!--            <v-row class="print-show top-center" >-->
<!--                <span>Centar za informacijske tehnologije Sveučilišta u Mostaru, SUMIT <br> A: Trg hrvatskih velikana 1, 88000 Mostar, BiH | E: sumit@sum.ba | W: https://sumit.sum.ba</span>-->
<!--            </v-row>-->
<!--            <row>-->
<!--                <img class="print-show" width="100%" src="../../assets/img/footer.png"/>-->
<!--            </row>-->
<!--        </div>-->

    </v-container>

</template>

<script>
    import ApiV2 from '@/services/ApiV2'
    export default {
        name: "SchoolPlansReport",
        data: () => ({
            educationalFields: [],
            educationalFieldId: null,
            selectedSchool: null,
            primarySchool: false,
            showTable: false,
            items: [],
            headers: [],
            cantons: [],
            timestamp: "",
            select_canton: 2,
            selected_canton_title: '',
            headerPrimary: [
                {text: "Naziv predmeta", value: "title", sortable: false,},
                {text: "1.", value: "subject_group_subjects[0]", sortable: false,},
                {text: "2.", value: "subject_group_subjects[1]", sortable: false,},
                {text: "3.", value: "subject_group_subjects[2]", sortable: false,},
                {text: "4.", value: "subject_group_subjects[3]", sortable: false,},
                {text: "5.", value: "subject_group_subjects[4]", sortable: false,},
                {text: "6.", value: "subject_group_subjects[5]", sortable: false,},
                {text: "7.", value: "subject_group_subjects[6]", sortable: false,},
                {text: "8.", value: "subject_group_subjects[7]", sortable: false,},
                {text: "9.", value: "subject_group_subjects[8]", sortable: false,}
            ],
            headersHigh: [
                {text: "Naziv predmeta", value: "title", sortable: false,},
                {text: "I.", value: "subject_group_subjects[11]", sortable: false,},
                {text: "II.", value: "subject_group_subjects[12]", sortable: false,},
                {text: "III.", value: "subject_group_subjects[13]", sortable: false,},
                {text: "IV.", value: "subject_group_subjects[14]", sortable: false,},
            ]
        }),
        mounted() {
            this.getEducationalFields();
            this.getCantons();
        },
        created(){
            setInterval(this.getNow,1000);
        },
        methods: {
            getEducationalFields() {
                ApiV2.get(`educational_fields`, {
                    params: {
                        "filter[parent_id]": "n=",
                        with: "children"
                    }
                }).then(response => {
                    this.educationalFields = response.data.data;
                });
            },

            getEducationalFieldsTable() {
                ApiV2.get(`report_school_plans`, {
                    params: {
                        cantonId: this.select_canton,
                        educationalFieldId: this.educationalFieldId
                    }
                }).then(response => {
                    this.items = response.data;
                });
                console.log(this.select_canton)
                this.cantons.items.forEach(element => {
                    if (element.id === this.select_canton) {
                        this.selected_canton_title = element.title
                    }
                })
            },

            changeEducationalFieldId(val) {
                this.cantons.items.forEach(element => {
                    if (element.id === this.select_canton) {
                        this.selected_canton_title = element.title
                    }
                })
                if (val.name.startsWith('Osnovna')) {
                    this.primarySchool = true,
                        this.headers = this.headerPrimary
                } else {
                    this.headers = this.headersHigh
                }
                this.showTable = true
                this.selectedSchool = val.name;
                this.educationalFieldId = val.id;
                this.getEducationalFieldsTable();
            },

            print() {
                window.print();
            },
            getCantons() {
                this.$axios.post('zupanija').then((response) => {
                    this.cantons = response.data;
                })
            },


            scroll(){
                const element = document.getElementById('table_npp');
                element.scrollIntoView({behavior:'smooth'});

            },

            getNow: function () {

                const today = new Date();
                const time = ((today.getHours()<10 ? '0':'')+today.getHours()) + ":" + ((today.getMinutes()<10 ? '0':'')+today.getMinutes()) + ":" + ((today.getSeconds()<10 ? '0':'')+today.getSeconds());
                this.timestamp = time;
            }

        }
    }
</script>

<style lang="scss">

    .color {
        color: #084776;
    }
    /*@media print {*/

    /*    tr:nth-child(15n) {*/
    /*        color: brown;*/
    /*        page-break-after: always;*/

    /*    }*/
    /*}*/

    @media print {

       /* body{    overflow:visible;  }*/
       /*tbody > tr:not(:first-child):nth-child(22n) {*/
       /*      display: block;*/
       /*      page-break-after: always !important;*/

       /*    !*page-break-after: always;*!*/
       /* }*/


        tr {
            display: block;
            border: 1px solid black;
            /*page-break-after: always;*/

        }


        tr th:first-child {
            width: 70px !important;

        }

        tr td:first-child {
            width: 70px;

        }
        tr td:not(:first-child) {
            width: 70px !important;

        }

        tr th:not(:first-child) {
            width: 70px !important;

        }
    }


    .plans-table {

        td {
            text-align: center;
            height: 20px !important;
            padding-left: 70px;
            padding-top: 40px;
            font-size: 13px!important;

        }
        tr th:first-child {
            width: 70% !important;

        }
        tr td:first-child {
            width: 70% !important;

        }
        tr td:not(:first-child) {
            width: 50px !important;


        }

        tr th:not(:first-child) {
            width: 50px !important;

        }

    }

    @page {
        size: A4;
        display: block;
        margin-left: 2cm;
        margin-right: 1.5cm;
        margin-bottom: 0.7cm;

    }


    /*@media print {*/
    /*    .footer-plans {*/
    /*        position: fixed;*/
    /*        bottom: 0 !important;*/

    /*    }*/

    /*    .plans-table tbody {*/
    /*        > td:nth-child(33n) {*/
    /*            page-break-inside: avoid;*/
    /*        }*/
    /*    }*/

    /*    html, body {*/
    /*        width: 210mm;*/
    /*        height: 297mm;*/
    /*    }*/
    /*}*/


    /*.footer-plans {*/
    /*        position: fixed;*/
    /*        bottom: 0 !important;*/
    /*}*/
    .top-center {
        padding-top: 10px;
        font-size: 11px;
        top: 12px;
        text-align: center;
        margin-bottom: 10px;

    }

    .top-right {
        padding-top: 10px;
        font-size: 11px;
        top: 12px;
        text-align: right;
    }

    .top-left {
        padding-top: 10px;
        font-size: 13px;
        top: 12px;
        text-align: left;
    }


    /*@media print {*/
    /*  @page{*/
    /*    margin-bottom: 2cm;*/

    /*    margin-left: 2cm;*/
    /*    margin-right: 1cm;*/
    /*  }*/
    /*  a[href]:after {*/
    /*    content: none !important;*/
    /*  }*/
    /*}*/
/*    @page {
        display: none;
        margin-left: 60px;
        margin-bottom: 2cm;
        margin-right: 1.5cm;

    }*/

    /*@media print {*/
    /*  @page{*/
    /*    margin-top: 0;*/
    /*    margin-bottom: 0;*/
    /*  }*/
    /*  body {*/
    /*    padding-top: 72px;*/
    /*    padding-bottom: 72px ;*/
    /*  }*/
    /*}*/


</style>